import type { MenuRegistry } from './types'
import nsmallMenu from './families/nsmall'
import smallifMenu from './families/smallif'
import erp1Menu from './families/erp1'
import fatoraMenu from './families/fatora'
import erpMenu from './families/erp'
import erpCrmMenu from './families/erpCrm'
import erpsam3Menu from './families/erpsam3'
import erpsamMenu from './families/erpsam'
import erptechMenu from './families/erptech'
import shaikhMenu from './families/shaikh'
import zeenahnMenu from './families/zeenahn'
import erpsamPOSMenu from './families/erpsamPOS'
import samPOSMenu from './families/samPOS'
import yeserpsamMenu from './families/yeserpsam'
import demoerpsamMenu from './families/demoerpsam'
import samerpproMenu from './families/samerppro'
import samstoreMenu from './families/samstore'
import fatstoreMenu from './families/fatstore'
import samerpMenu from './families/samerp'
import esamerpMenu from './families/esamerp'
import demosamerpMenu from './families/demosamerp'
import partiesMenu from './families/parties'
import demosmallMenu from './families/demosmall'
import smallMenu from './families/small'
import small_mentMenu from './families/small_ment'
import whatsappMenu from './families/whatsapp'
import sfatoraMenu from './families/sfatora'
import fullMenu from './families/full'
import fatooraMenu from './families/fatoora'
import ofatoraMenu from './families/ofatora'
import osfatoraMenu from './families/osfatora'
import OsamPOSMenu from './families/OsamPOS'

export const menuRegistry: MenuRegistry = {
  nsmall: nsmallMenu,
  smallif: smallifMenu,
  erp1: erp1Menu,
  fatora: fatoraMenu,
  erp: erpMenu,
  erpCrm: erpCrmMenu,
  erpsam3: erpsam3Menu,
  erpsam: erpsamMenu,
  erptech: erptechMenu,
  shaikh: shaikhMenu,
  zeenahn: zeenahnMenu,
  erpsamPOS: erpsamPOSMenu,
  samPOS: samPOSMenu,
  yeserpsam: yeserpsamMenu,
  demoerpsam: demoerpsamMenu,
  samerppro: samerpproMenu,
  samstore: samstoreMenu,
  fatstore: fatstoreMenu,
  samerp: samerpMenu,
  esamerp: esamerpMenu,
  demosamerp: demosamerpMenu,
  parties: partiesMenu,
  demosmall: demosmallMenu,
  small: smallMenu,
  small_ment: small_mentMenu,
  whatsapp: whatsappMenu,
  sfatora: sfatoraMenu,
  full: fullMenu,
  fatoora: fatooraMenu,
  ofatora: ofatoraMenu,
  osfatora: osfatoraMenu,
  OsamPOS: OsamPOSMenu,
}

const deviceRentalMenuItem = {
  index: 12,
  arname: 'تأجير الاجهزة',
  enname: 'Device Rental',
  href: '/device-rentals',
  class: '',
  style: '',
  smclass: '',
  groupid: [],
  perms: ['show_jobcard'],
  accessPerms: ['maintenance.rentals.read'],
}

const maintenanceRatingMenuItem = {
  index: 13,
  arname: 'تقييم الصيانة',
  enname: 'Maintenance Ratings',
  href: '/maintenance-ratings',
  class: '',
  style: '',
  smclass: '',
  groupid: [],
  perms: ['show_jobcard'],
  accessPerms: ['maintenance.reports.work'],
}

function addDeviceRentalMenuItems(registry: MenuRegistry): void {
  Object.values(registry).forEach((family) => {
    const sections = Object.values(family)
    const target = sections.find((section) => {
      const tabs = Array.isArray(section.sub) ? section.sub : []
      return tabs.some((tab) => ['/home', '/general-maintenance', '/checkupdevice', '/technician/job-items'].includes(tab.href || ''))
    })

    if (!target) return
    target.sub = Array.isArray(target.sub) ? target.sub : []
    if (target.sub.some((tab) => tab.href === '/device-rentals')) return

    const item = {
      ...deviceRentalMenuItem,
      main: target.main && target.main.index ? target.main.index : deviceRentalMenuItem.index,
    }
    const jobOrderIndex = target.sub.findIndex((tab) => ['/home', '/general-maintenance'].includes(tab.href || ''))
    if (jobOrderIndex >= 0) {
      target.sub.splice(jobOrderIndex + 1, 0, item)
    } else {
      target.sub.push(item)
    }
  })
}

addDeviceRentalMenuItems(menuRegistry)

function addMaintenanceRatingMenuItems(registry: MenuRegistry): void {
  Object.values(registry).forEach((family) => {
    const sections = Object.values(family)
    const target = sections.find((section) => {
      const tabs = Array.isArray(section.sub) ? section.sub : []
      return tabs.some((tab) => ['/home', '/general-maintenance', '/reports/technician-work', '/workreps'].includes(tab.href || ''))
    })

    if (!target) return
    target.sub = Array.isArray(target.sub) ? target.sub : []
    if (target.sub.some((tab) => tab.href === '/maintenance-ratings')) return

    const item = {
      ...maintenanceRatingMenuItem,
      main: target.main && target.main.index ? target.main.index : maintenanceRatingMenuItem.index,
    }
    const reportIndex = target.sub.findIndex((tab) => ['/reports/technician-work', '/workreps'].includes(tab.href || ''))
    if (reportIndex >= 0) {
      target.sub.splice(reportIndex + 1, 0, item)
    } else {
      target.sub.push(item)
    }
  })
}

addMaintenanceRatingMenuItems(menuRegistry)

export default menuRegistry
